import _merge from 'lodash/merge';
import _memoize from 'lodash/memoize';
import { Lightning } from '@lightningjs/sdk';
import { FONT, getFont } from '@tornado-rdk/typography';
import { FULL_HD, HD } from '@bedrock-rdk/constants';
import { t } from '../../../../../../i18n';

import Icon from '../../../../../icon/icon.component';

export const screenSize = 'FULL_HD';

export const ICON_SIZE = {
  WIDTH: {
    [HD]: 24,
    [FULL_HD]: 32,
  },
  HEIGHT: {
    [HD]: 24,
    [FULL_HD]: 32,
  },
};
export const ERROR_ICON = { name: 'ErrorEmoji', type: 'icon' };

export const getIconViewBox = _memoize(screenSize => ({
  w: ICON_SIZE.WIDTH[screenSize],
  h: ICON_SIZE.HEIGHT[screenSize],
}));

export class ProgramCardError extends Lightning.Component {
  static _template() {
    return _merge({
      flex: { direction: 'row', justifyContent: 'center' },
      Icon: {
        flexItem: { marginRight: 12 },
        type: Icon,
        iconData: {
          picto: ERROR_ICON,
          viewBox: getIconViewBox(screenSize),
        },
      },
      Title: {
        flexItem: { marginTop: 6, marginRight: 12 },
        text: {
          ...getFont(FONT.OTTAWA_3, screenSize),
          text: t('programCard.noContent'),
        },
      },
    });
  }
}
